interface MetricCardProps {
  label: string;
  value: string | number;
  icon: string;
  trend?: { value: number; isPositive: boolean };
  colorClass: string;
  bgClass: string;
}

export default function MetricCard({ label, value, icon, trend, colorClass, bgClass }: MetricCardProps) {
  return (
    <div className="bg-white dark:bg-background-100 rounded-xl border border-background-200 dark:border-background-300 p-5 hover:border-background-300 dark:hover:border-background-400 transition-colors">
      <div className="flex items-start justify-between">
        <div className="space-y-2">
          <p className="text-xs font-medium text-foreground-500 uppercase tracking-wider">{label}</p>
          <p className="text-2xl font-heading font-bold text-foreground-950 dark:text-foreground-100">
            {typeof value === 'number' ? value.toLocaleString('pt-BR') : value}
          </p>
          {trend && (
            <div className="flex items-center gap-1">
              <i className={`text-xs ${trend.isPositive ? 'ri-arrow-up-line text-emerald-500' : 'ri-arrow-down-line text-red-500'}`} />
              <span className={`text-xs font-medium ${trend.isPositive ? 'text-emerald-600 dark:text-emerald-400' : 'text-red-600 dark:text-red-400'}`}>
                {trend.value}%
              </span>
              <span className="text-xs text-foreground-400">vs mês anterior</span>
            </div>
          )}
        </div>
        <div className={`w-10 h-10 rounded-lg ${bgClass} flex items-center justify-center`}>
          <i className={`${icon} text-lg ${colorClass}`} />
        </div>
      </div>
    </div>
  );
}